import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		margin: '0 auto',
		width: '100%',
		height: '100%',
		overflowX: 'hidden',
		maxWidth: '100vw',
		boxSizing: 'border-box',
		flex: 1,
	},
	modalContent: {
		containerType: 'inline-size',
		maxHeight: '85vh',
		minWidth: 650,
		overflowY: 'auto',
		width: '100%',
	},
});
